// extracted by mini-css-extract-plugin
export default {"description":"Faculty_description__Q32yC","row":"Faculty_row__vFCXZ","element":"Faculty_element__LUVZ0","title":"Faculty_title__IaU5K","learnMore":"Faculty_learnMore__ztqt7"};